import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';

export default function BooksPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <Navigation />

      {/* Hero Section */}
      <section className="pt-32 pb-24 px-6 bg-stone-50">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-light text-gray-900 mb-6 tracking-wide">
            Poetry Collections
          </h1>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Explore Kent Zimmerman's published works—each collection a unique journey through emotion, imagery, and artistic expression.
          </p>
          <div className="w-24 h-1 bg-amber-700 mx-auto mt-8"></div>
        </div>
      </section>

      {/* Books Grid */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-12">
            {/* Nine Lives */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-full h-96">
                <img
                  src="https://static.readdy.ai/image/29014cc4b7daa6d5c6988d1d2c1b8cc2/8cd51400f5e86b2d53787e93c02816bd.jpeg"
                  alt="Nine Lives"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-light text-gray-900 mb-4 tracking-wide">
                  Nine Lives
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-6">
                  Nine Lives is a poetic exploration of transformation and survival—nine chapters of rebirth, reflection, and renewal. Blending vivid imagery with emotional storytelling, the collection captures the human spirit's ability to rise again and again.
                </p>
                <div className="mb-6">
                  <p className="text-xs text-gray-500 uppercase tracking-widest mb-2">
                    Available Formats:
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-stone-50 text-gray-700 text-xs rounded-full">
                      Ebook
                    </span>
                    <span className="px-3 py-1 bg-stone-50 text-gray-700 text-xs rounded-full">
                      Paperback
                    </span>
                    <span className="px-3 py-1 bg-stone-50 text-gray-700 text-xs rounded-full">
                      Audiobook
                    </span>
                  </div>
                </div>
                <a
                  href="https://www.amazon.ca/Nine-Lives-Kent-Zimmerman-ebook/dp/B0FJZQ56SQ/ref=sr_1_1?crid=1Q0LQZOWHUNX5&dib=eyJ2IjoiMSJ9.0-IMscWxJ_c-H4hABS6QuYKwDRNncau8gmn1zE3wxkQ.4VCOVwWJCGpm6NsUSAochJMnwmhohJogmFmnno3mliM&dib_tag=se&keywords=Nine+Lives+Kent+Zimmerman&qid=1765313271&s=books&sprefix=nine+lives+kent+zimmerm%2Cstripbooks%2C354&sr=1-1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block w-full text-center px-8 py-3 bg-amber-700 text-white text-sm font-light tracking-widest uppercase hover:bg-amber-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  View on Amazon
                </a>
              </div>
            </div>

            {/* Meta Postal Expression */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-full h-96">
                <img
                  src="https://static.readdy.ai/image/29014cc4b7daa6d5c6988d1d2c1b8cc2/1a00de3e7b8c11d3e24337996a397f27.jpeg"
                  alt="Meta Postal Expression"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-light text-gray-900 mb-4 tracking-wide">
                  Meta Postal Expression
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-6">
                  Meta Postal Expression takes readers on a reflective journey through letters, symbols, and metaphors. Each poem acts like a message—sent, received, or lost—inviting exploration of memory, communication, and connection.
                </p>
                <div className="mb-6">
                  <p className="text-xs text-gray-500 uppercase tracking-widest mb-2">
                    Available Formats:
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-stone-50 text-gray-700 text-xs rounded-full">
                      Ebook
                    </span>
                    <span className="px-3 py-1 bg-stone-50 text-gray-700 text-xs rounded-full">
                      Paperback
                    </span>
                    <span className="px-3 py-1 bg-stone-50 text-gray-700 text-xs rounded-full">
                      Audiobook
                    </span>
                  </div>
                </div>
                <a
                  href="https://www.amazon.com/Meta-Postal-Expression-Kent-Zimmerman-ebook/dp/B0FQFNS5LS/ref=sr_1_1?dib=eyJ2IjoiMSJ9.kT4K81mMXCqdD-CazUYXXttAwWz9YYLtwhlJcEV5YheShqjDki3Ph1rS-zDOn2lxutI-pEliURNpyeKEbAvj5iCtDO7vWFt7oeNPmJpC_O-n9AtABtJuWkqlUuDyyrAD.x6g31Lre5M6Y_BUQKV-QwEuEIKyCSRXo5TBf-_6eFQA&dib_tag=se&keywords=meta+postal&qid=1766094026&s=books&sr=1-1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block w-full text-center px-8 py-3 bg-amber-700 text-white text-sm font-light tracking-widest uppercase hover:bg-amber-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  View on Amazon
                </a>
              </div>
            </div>

            {/* Silkfoot */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-full h-96">
                <img
                  src="https://static.readdy.ai/image/29014cc4b7daa6d5c6988d1d2c1b8cc2/a3badd4d4ba31fa31ed34cc66d5a4d8c.jpeg"
                  alt="Silkfoot"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-light text-gray-900 mb-4 tracking-wide">
                  Silkfoot
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-6">
                  Silkfoot is a gentle, soulful collection celebrating movement, softness, and presence. Through delicate yet evocative language, readers are invited into a world of introspection and artistic rhythm.
                </p>
                <div className="mb-6">
                  <p className="text-xs text-gray-500 uppercase tracking-widest mb-2">
                    Available Formats:
                  </p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-stone-50 text-gray-700 text-xs rounded-full">
                      Ebook
                    </span>
                    <span className="px-3 py-1 bg-stone-50 text-gray-700 text-xs rounded-full">
                      Paperback
                    </span>
                    <span className="px-3 py-1 bg-stone-50 text-gray-700 text-xs rounded-full">
                      Audiobook
                    </span>
                  </div>
                </div>
                <a
                  href="https://www.amazon.com/Silkfoot-Kent-Zimmerman/dp/1965679323/ref=monarch_sidesheet_title"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block w-full text-center px-8 py-3 bg-amber-700 text-white text-sm font-light tracking-widest uppercase hover:bg-amber-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  View on Amazon
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-6 bg-stone-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-wide">
            Experience the Full Journey
          </h2>
          <p className="text-base md:text-lg text-gray-600 mb-12 leading-relaxed">
            Each book is accompanied by original artwork and available as an audiobook. Explore the visual and auditory dimensions of Kent's poetry.
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <Link
              to="/artwork"
              className="inline-block px-10 py-4 bg-gray-900 text-white text-sm font-light tracking-widest uppercase hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View Artwork
            </Link>
            <Link
              to="/audiobooks"
              className="inline-block px-10 py-4 border border-gray-900 text-gray-900 text-sm font-light tracking-widest uppercase hover:bg-gray-900 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Listen to Audiobooks
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
